import { useState, useEffect } from "react";

import timeService from "../../../../../../services/timeService";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function ListTime(props) {
  const { expedienteId, refreshTimes } = props;

  const [times, setTimes] = useState([]);
  const [totalTime, setTotalTime] = useState("");
  const [loading, setLoading] = useState(true);
  const [successSB, setSuccessSB] = useState(false);
  const closeSuccessSB = () => setSuccessSB(false);
  const [errorSB, setErrorSB] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const closeErrorSB = () => setErrorSB(false);

  useEffect(() => {
    async function fetchTimes() {
      setLoading(true);
      try {
        const data = await timeService.getTimebyExpedienteId(expedienteId);
        setTimes(data);
        setTotalTime(data.reduce((sum, item) => sum + item.elapsed_time, 0));
      } catch (error) {
        setErrorMessage("Error al cargar los registros de tiempo");
        setErrorSB(true);
      } finally {
        setLoading(false);
      }
    }
    fetchTimes();
  }, [expedienteId, refreshTimes]);

  const handleDelete = async (id) => {
    const shouldDelete = window.confirm("¿Realmente desea eliminar este registro?");
    if (shouldDelete) {
      await timeService.deleteTimeById(id);
      setTimes((prevRows) => prevRows.filter((row) => row.id !== id));
      setSuccessSB(true);
    }
  };

  function formatTimeFromMinutes(totalMinutes) {
    const date = new Date(totalMinutes * 60 * 1000);
    return date.toISOString().slice(11, 16);
  }

  const listTimes = times.map((t) => (
    <MDBox key={t.id} component="li" display="flex" alignItems="center" py={1} mb={1}>
      <MDBox display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center">
        <MDTypography variant="button" fontWeight="medium">
          {t.description}
        </MDTypography>
        <MDTypography variant="caption" color="text">
          {t.created_date}
        </MDTypography>
      </MDBox>
      <MDBox ml="auto">
        <MDTypography variant="button" fontWeight="regular" color="text" mr={2}>
          {t.elapsed_time}
        </MDTypography>
        <MDButton variant="text" color="error" size="small" onClick={() => handleDelete(t.id)}>
          Eliminar
        </MDButton>
      </MDBox>
    </MDBox>
  ));

  const renderSuccessSB = (
    <MDSnackbar
      color="success"
      icon="check"
      title="Registro agregado correctamente!"
      content="Registro agregado correctamente!"
      dateTime=""
      open={successSB}
      onClose={closeSuccessSB}
      close={closeSuccessSB}
    />
  );

  const renderErrorSB = (
    <MDSnackbar
      color="error"
      icon="warning"
      title="Error"
      content={errorMessage}
      dateTime=""
      open={errorSB}
      onClose={closeErrorSB}
      close={closeErrorSB}
      bgWhite
    />
  );

  if (loading) {
    return (
      <MDBox display="flex" justifyContent="center" p={2}>
        <CircularProgress size={24} color="info" />
      </MDBox>
    );
  }

  if (times.length > 0) {
    return (
      <Card>
        <MDBox position="relative" p={3}>
          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
            Tiempo total: { formatTimeFromMinutes(totalTime)} hs.
          </MDTypography>
          <MDBox component="ul" display="flex" flexDirection="column" pt={2} m={0}>
            {listTimes}
          </MDBox>
          {renderSuccessSB}
          {renderErrorSB}
        </MDBox>
      </Card>
    );
  } else {
    return "";
  }
}

ListTime.propTypes = {
  expedienteId: PropTypes.number.isRequired,
  refreshTimes: PropTypes.bool,
};

export default ListTime;
